import { getData } from "../../axios/axiosHelper";
import { buildRegistrationReviewQuery } from "./registrationReviewQuery";

const CACHE_TTL_MS = 45_000;
const MAX_CACHE_ENTRIES = 20;
const cache = new Map();
const pendingRequests = new Map();

const pruneCache = () => {
  if (cache.size <= MAX_CACHE_ENTRIES) return;
  const oldestKey = cache.keys().next().value;
  if (oldestKey) cache.delete(oldestKey);
};

export const getCachedRegistrationReviewQueue = (url) => {
  const entry = cache.get(url);
  if (!entry) return null;
  if (Date.now() - entry.savedAt > CACHE_TTL_MS) {
    cache.delete(url);
    return null;
  }
  return entry.response;
};

export const loadRegistrationReviewQueue = (url, { force = false } = {}) => {
  if (!force) {
    const cached = getCachedRegistrationReviewQueue(url);
    if (cached) return Promise.resolve(cached);
  }
  if (pendingRequests.has(url)) return pendingRequests.get(url);

  const request = getData(url, true)
    .then((response) => {
      cache.set(url, { response, savedAt: Date.now() });
      pruneCache();
      return response;
    })
    .finally(() => pendingRequests.delete(url));

  pendingRequests.set(url, request);
  return request;
};

export const clearRegistrationReviewQueueCache = () => {
  cache.clear();
};

export const buildDefaultRegistrationReviewQueueUrl = (
  type = "customers"
) => {
  const normalizedType = type === "merchants" ? "merchants" : "customers";
  const query = buildRegistrationReviewQuery({ type: normalizedType });
  query.delete("type");
  return `/admin/registration-reviews/${normalizedType}?${query.toString()}`;
};

export const prefetchDefaultRegistrationReviewQueue = (
  type = "customers"
) =>
  loadRegistrationReviewQueue(
    buildDefaultRegistrationReviewQueueUrl(type)
  ).catch(() => null);
